import { FEATURES_BY_ID, type FeatureId } from '@/data/featuresRegistry';
import { Icon } from '@/design-system/icons/Icon';
import { Button } from '@/components/atoms/Button';
import { useFeaturesStore } from '@/stores/features';
import { useCurrentUser } from '@/stores/auth';

type Props = { feature: FeatureId };

export const DisabledView = ({ feature }: Props) => {
  const meta = FEATURES_BY_ID[feature];
  const set = useFeaturesStore((s) => s.set);
  const user = useCurrentUser();
  return (
    <div style={{ padding: 60, textAlign: 'center', color: 'var(--ink-3)' }} data-reveal>
      <Icon name={meta.icon} size={32} />
      <h2 style={{ fontFamily: 'var(--font-serif)', margin: '14px 0 6px', color: 'var(--ink)' }}>
        {meta.label} está desativado
      </h2>
      <p style={{ maxWidth: 520, margin: '0 auto 18px' }}>{meta.desc}</p>
      {user?.role === 'admin' && <Button onClick={() => void set(feature, true)}>Reativar agora</Button>}
    </div>
  );
};
